import {
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Link,
  Popover,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState, MouseEvent } from 'react';
import { useSelector } from 'react-redux';
import { useHook as globalAlertHook } from './useHook';
import { useAlert } from '../../../components/Notification';
import { Pagination } from '../../../components';
import { ReactComponent as SearchIcon } from '../../../assets/images/Search.svg';
import { useHook as EquipmentHook } from '../hardware/equipments/useHook';
import { useLocation, useNavigate } from 'react-router-dom';
import emptyFolter from '../../../assets/images/empty-folder 2.svg';
import { closeBlackIcon } from '../../../assets/images';
import Filter from '../../../assets/images/Filter.svg';
import { DateRangePicker } from 'react-date-range';
import { startOfMonth, endOfMonth } from 'date-fns';
import audiLogDate from '../../../assets/images/AudiLogDate.svg';
import { format } from 'date-fns';
import { useHook as InventoryUseHook } from '../inventory/useHook';
interface AlertProps {
  getGlobalAlertData: () => void;
}
const Alert: React.FC<AlertProps> = ({ getGlobalAlertData }) => {
  const showAlert = useAlert();
  const navigate = useNavigate();
  const location = useLocation();
  const userRole = localStorage.getItem('role');
  const equipmentId = location.state?.id; // Access the passed data
  const equipmentType = location.state?.equipmentType; // Access the passed data
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const { fetchGlobalAlert, fetchDealerGlobalAlert, markAsRead } =
    globalAlertHook();
  const { fetchGetAllEquipmentList, fetchGetAllDealerEquipmentList } =
    EquipmentHook();
  const { fetchRisteredInventory, fetchDealerRisteredInventory } =
    InventoryUseHook();
  const [activeAlert, setActiveAlert] = useState('all');
  const [allAlertIds, setAllAlertIds] = useState([]);
  const { globalAlert } = useSelector((state: any) => state.globalAlert);
  const [userAnchorEl, setUserAnchorEl] = useState<null | HTMLElement>(null);
  const [equipmentList, setEquipmentList] = useState([]);
  const [equipmentResponse, setEquipmentResponse] = useState<any>({});
  const [filterEquipmentList, setFilteredEquipmentList] = useState([]);
  const [selectedEquipment, setSelectedEquipment] = useState<string[]>([]);
  const [initialEquipmentApi, setinitialEquipmentApi] = useState(false);
  const [alertList, setAlertList] = useState([]);
  const [seeMoreIndex, setSeeMoreIndex] = useState<number>(2);
  const [dateAnchorEl, setDateAnchorEl] = useState<null | HTMLElement>(null);

  const startToday = new Date();
  startToday.setHours(0, 0, 0, 0);
  const startOfCurrentMonth = startOfMonth(new Date());
  const endOfCurrentMonth = endOfMonth(new Date());

  const [selectionRange, setSelectionRange] = useState({
    startDate: startOfCurrentMonth,
    endDate: endOfCurrentMonth,
    key: 'selection',
  });

  const changeFormat = (date: number | Date) => {
    return format(date, 'MMM d, yyyy');
  };

  //find equipmentname
  const findEquipmentName = (deviceId: string) => {
    if (equipmentList?.length > 0) {
      if (deviceId) {
        const findrole: any = equipmentList?.find(
          (equipment: any) => equipment.unitID == deviceId,
        );
        return findrole?.equipmentModel || deviceId;
      } else {
        return deviceId;
      }
    } else {
      return deviceId;
    }
  };
  //getEquipment
  const getEquipment = async () => {
    try {
      if (userRole == 'dealer') {
        const res: any = await fetchDealerRisteredInventory({}); // Await the API call properly

        setEquipmentList(res?.data);
        setFilteredEquipmentList(res?.data);
        setEquipmentResponse(res?.data);
        const getEquipmentIds = res?.data?.map(
          (data: { unitID: any }) => data?.unitID,
        );
        if (equipmentId) {
          setSelectedEquipment([equipmentId]);
          getData(currentPage, rowsPerPage, [equipmentId]);
          // navigate(location.pathname, { replace: true, state: null });
        } else {
          getData(currentPage, rowsPerPage, []);
        }
      } else {
        const res: any = await fetchRisteredInventory({}); // Await the API call properly

        setEquipmentList(res?.data);
        setFilteredEquipmentList(res?.data);
        setEquipmentResponse(res?.data);
        const getEquipmentIds = res?.data?.map(
          (data: { unitID: any }) => data?.unitID,
        );
        if (equipmentId) {
          setSelectedEquipment([equipmentId]);
          getData(currentPage, rowsPerPage, [equipmentId]);
          // navigate(location.pathname, { replace: true, state: null });
        } else {
          getData(currentPage, rowsPerPage, []);
        }
      }
    } catch (error) {
      console.error('Error fetching equipment data:', error);
    }
  };

  useEffect(() => {
    if (initialEquipmentApi) {
      getData(1, rowsPerPage, selectedEquipment);
      setCurrentPage(1);
    }
  }, [selectedEquipment, selectionRange, activeAlert]);
  //filter dropdown
  const userOpen = Boolean(userAnchorEl);
  const userId = userOpen ? 'simple-popover' : undefined;
  const handleUserClose = () => {
    setUserAnchorEl(null);
    setFilteredEquipmentList(equipmentList);
  };
  const handleUserClick = (event: MouseEvent<HTMLElement>): void => {
    setUserAnchorEl(event.currentTarget);
  };

  const handleEquipmentSearch = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const query = event.target.value.toLowerCase();
    const filtered = equipmentList.filter((role: { equipmentModel: string }) =>
      role.equipmentModel?.toLowerCase().includes(query),
    );
    setFilteredEquipmentList(filtered);
  };
  const handleEquipmentSelection = (roleName: string | undefined) => {
    if (!roleName) return;
    setinitialEquipmentApi(true);
    setSelectedEquipment((prevSelectedRoles) => {
      if (prevSelectedRoles.includes(roleName)) {
        const updatedRoles = prevSelectedRoles.filter(
          (role) => role !== roleName,
        );
        return updatedRoles;
      } else {
        const updatedRoles = [...prevSelectedRoles, roleName];
        return updatedRoles;
      }
    });
  };

  const handlePage = (item: any) => {
    setinitialEquipmentApi(true);
    setActiveAlert(item);
    // setSelectedEquipment(equipmentId ? [equipmentId] : []);
    // setSelectionRange({
    //   startDate: startOfCurrentMonth,
    //   endDate: endOfCurrentMonth,
    //   key: 'selection',
    // });
  };
  //pagination
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getData(page, rowsPerPage, selectedEquipment);
  };
  const handleRowsPerPageChange = (value: number) => {
    getData(1, value, selectedEquipment);
    setRowsPerPage(value);
    setCurrentPage(1);
  };

  const getData = async (
    pagenumber?: number,
    row_perpage?: number,
    filters: any = [],
    sort: { orderBy: string; order: number } = {
      orderBy: 'createdAt',
      order: -1,
    },
  ) => {
    const payload = userRole == 'dealer' ?{
      sort: sort,
      // search: search,
      filters: {
        from: selectionRange.startDate
          ? selectionRange.startDate.toISOString()
          : undefined,
        to: selectionRange.endDate
          ? selectionRange.endDate.toISOString()
          : undefined,
        isUnread:
          activeAlert !== 'all'
            ? activeAlert === 'unread'
              ? 'true'
              : 'false'
            : undefined,
        deviceID: filters,
      },
      limit: row_perpage ? row_perpage : rowsPerPage,
      offset: pagenumber
        ? (pagenumber - 1) * rowsPerPage
        : (currentPage - 1) * rowsPerPage,
    }: {
      sort: sort,
      // search: search,
      filters: {
        from: selectionRange.startDate
          ? selectionRange.startDate.toISOString()
          : undefined,
        to: selectionRange.endDate
          ? selectionRange.endDate.toISOString()
          : undefined,
        isUnread:
          activeAlert !== 'all'
            ? activeAlert === 'unread'
              ? 'true'
              : 'false'
            : undefined,
       ids: filters,
      },
      limit: row_perpage ? row_perpage : rowsPerPage,
      offset: pagenumber
        ? (pagenumber - 1) * rowsPerPage
        : (currentPage - 1) * rowsPerPage,
    };

    if (userRole == 'dealer') {
      await fetchDealerGlobalAlert(payload).then((res: any) => {
        const totalPage = res?.count
          ? Math.ceil(res?.count / (row_perpage ? row_perpage : rowsPerPage))
          : 1;
        setTotalPages(totalPage);
        if (res?.data) {
          setAlertList(res?.data);
          const getallAlertId = res?.data?.map(
            (data: { alertID: any }) => data?.alertID,
          );
          setAllAlertIds(getallAlertId);
          // getGlobalAlertData()
        }
      });
    } else {
      await fetchGlobalAlert(payload).then((res: any) => {
        const totalPage = res?.count
          ? Math.ceil(res?.count / (row_perpage ? row_perpage : rowsPerPage))
          : 1;
        setTotalPages(totalPage);
        if (res?.data) {
          setAlertList(res?.data);
          const getallAlertId = res?.data?.map(
            (data: { alertID: any }) => data?.alertID,
          );
          setAllAlertIds(getallAlertId);
          // getGlobalAlertData()
        }
      });
    }
  };

  useEffect(() => {
    // getData();
    if (equipmentId) {
      setSelectedEquipment([equipmentId]);
      getData(currentPage, rowsPerPage, [equipmentId]);
    } else {
      getData(currentPage, rowsPerPage, []);
    }
    // getEquipment();
  }, []);

  const getRelativeTime = (time: string): string => {
    const givenTime = new Date(time);
    const currentTime = new Date();
    const diffInMilliseconds = currentTime.getTime() - givenTime.getTime();

    const diffInSeconds = Math.floor(diffInMilliseconds / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInSeconds < 60) {
      return `${diffInSeconds} seconds ago`;
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes} minutes ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hours ago`;
    } else if (diffInDays <= 7) {
      return `${diffInDays} days ago`;
    } else {
      return `${formatDate(givenTime)}`;
    }
  };

  //dateformat
  function formatDate(isoDate: any) {
    const months = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ];

    const date = new Date(isoDate);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12; // Convert 0 hours to 12 for AM/PM format
    const formattedHours = hours.toString();

    return `${day} ${month} ${year} ${formattedHours}:${minutes}:${seconds} ${ampm}`;
  }

  // markAsRead
  // const handleMarkAsRead = async (id: string[], action: boolean) => {
  //   const payload = {
  //     alertIDs: id,
  //     action,
  //   };
  //   await markAsRead(payload).then((res) => {
  //     if (res) {
  //       action
  //         ? showAlert('Changed to Read Successfully', 'success')
  //         : showAlert('Changed to Unread Successfully', 'success');
  //     }
  //   });
  //   await getData(currentPage, rowsPerPage, selectedEquipment);
  // };

  //navigate EquipmentDetails page
  const handleNavigateEquipment = (id: string, deviceName: string) => {
    navigate(`/inventory/equipmentdetails/${deviceName}/${id}`);

    // const ownedEquipment = equipmentResponse?.ownedEquipments?.map(
    //   (data: { unitID: any }) => data?.unitID,
    // );
    // const sharedEquipment = equipmentResponse?.sharedEquipments?.map(
    //   (data: { unitID: any }) => data?.unitID,
    // );
    // if (ownedEquipment?.includes(id)) {
    //   navigate(`/equipment/ownedequipment/details/${deviceName}/${id}`);
    // } else {
    //   navigate(`/equipment/sharedwithmeequipment/details/${deviceName}/${id}`);
    // }
  };

  //date popupopen
  const dateOpen = Boolean(dateAnchorEl);
  const dateId = dateOpen ? 'simple-popover' : undefined;

  const handleDateClick = (event: MouseEvent<HTMLElement>): void => {
    setDateAnchorEl(event.currentTarget);
  };

  const handleSelect = (ranges: any) => {
    setinitialEquipmentApi(true);
    setSelectionRange(ranges.selection);
    setCurrentPage(1);
  };

  const handleDateClose = () => {
    setDateAnchorEl(null);
  };
  return (
    <>
      <section>
        {/* <div className="alert-header">
          <div className="audilog_update notify">
            <Button
              onClick={() => {
                handlePage('all');
              }}
              className={activeAlert == 'all' ? 'activeEdit' : ''}
            >
              All
            </Button>
            <Button
              onClick={() => {
                handlePage('read');
              }}
              className={activeAlert == 'read' ? 'activeEdit' : ''}
            >
              Read
            </Button>
            <Button
              onClick={() => {
                handlePage('unread');
              }}
              className={activeAlert == 'unread' ? 'activeEdit' : ''}
            >
              Unread
            </Button>
          </div>

          <div className="alert-header-link">
            <Button onClick={() => handleMarkAsRead(allAlertIds, true)}>
              Mark all as read
            </Button>
          </div>
        </div> */}

        <div className="global_audilog">
          <div className="global_audilog_header">
            <Button
              className="global_audilog_date-btn global_buttons"
              aria-describedby={dateId}
              onClick={handleDateClick}
            >
              <img src={audiLogDate} width={24} alt="date img" />
              <Typography>Period</Typography>
            </Button>
            {/* <Button
              aria-describedby={userId}
              onClick={handleUserClick}
              className={
                selectedEquipment?.length > 0
                  ? ' global_audilog_date-btn global_buttons filter_buttons-active'
                  : 'global_audilog_date-btn global_buttons'
              }
            >
              <img src={Filter} width={24} alt="filter img" />
              <div className="typo_head ">
                {' '}
                <Typography>Select Equipment</Typography>
                {selectedEquipment?.length > 0 && (
                  <div className="filter_buttons-active-filtercount">
                    <p>{selectedEquipment?.length}</p>
                  </div>
                )}
              </div>
            </Button> */}
          </div>
        </div>

        <div className="auditlog_date_range">
          {changeFormat(selectionRange?.startDate) +
            ' - ' +
            changeFormat(selectionRange?.endDate)}
        </div>
        {equipmentType && (
          <div className="filterlist">
            <p>{equipmentType}</p>
          </div>
        )}

        {/* {selectedEquipment?.slice(0, seeMoreIndex)?.map((event, index) => (
          <div key={index} className="filterlist">
            <p>{findEquipmentName(event)}</p>
            {equipmentId && equipmentId !== event && (
              <Button onClick={() => handleEquipmentSelection(event)}>
                <img src={closeBlackIcon} alt="Delete Icon" width={13} />
              </Button>
            )}
          </div>
        ))}
        {selectedEquipment?.length > 2 && seeMoreIndex === 2 && (
          <div className="see_more_data">
            <Button
              onClick={() => setSeeMoreIndex(selectedEquipment?.length)}
            >{`+${selectedEquipment?.length - 2} More`}</Button>
          </div>
        )}
        {selectedEquipment?.length > 2 && seeMoreIndex !== 2 && (
          <div className="see_more_data">
            <Button onClick={() => setSeeMoreIndex(2)}>show less</Button>
          </div>
        )} */}
      </section>

      <section className="alert-section">
        {/* <p> Today</p> */}
        {activeAlert === 'all' ? (
          <>
            {alertList?.map((alertdata: any, index: number) => (
              <div key={index} className="alert_body">
                <div
                  className={
                    alertdata?.isUnread
                      ? 'alert_body-content alert_body_unread'
                      : 'alert_body-content '
                  }
                >
                  <div className="alert_body-content-head">
                    <div>
                      <h5>{alertdata?.title}</h5>
                      <Button
                        className="alert_body-content-head_btn"
                        onClick={() =>
                          handleNavigateEquipment(
                            alertdata?.deviceID,
                            alertdata?.deviceName,
                          )
                        }
                      >
                        {alertdata?.deviceName}
                      </Button>
                    </div>
                    <div className="equipment_alert-read_unread">
                      <p>{getRelativeTime(alertdata?.createdAt)}</p>
                      {/* <div
                        className={`user_management_status-data ${alertdata?.isUnread ? 'inactive' : 'active'}`}
                      >
                        {alertdata?.isUnread ? 'Unread' : 'Read'}
                      </div> */}
                      {/* <div className="markus_read_unread-btn">
                        <Button
                          onClick={() =>
                            handleMarkAsRead(
                              [alertdata?.alertID],
                              alertdata?.isUnread,
                            )
                          }
                        >
                          {alertdata?.isUnread
                            ? 'Mark as read'
                            : 'Mark as Unread'}
                        </Button>
                      </div> */}
                    </div>
                  </div>
                  <p className="alert_body-content-lines">
                    {alertdata?.description}
                  </p>
                </div>
              </div>
            ))}
            {alertList?.length > 0 && (
              <Pagination
                rowsPerPageOptions={[5, 10, 20, 30]}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
                totalPages={totalPages}
              />
            )}
            {!(alertList?.length > 0) && (
              <div className="global_audilog-nodata">
                <img src={emptyFolter} alt="nodata" width="120" height="120" />
                <h3>No Record Found!</h3>
              </div>
            )}
          </>
        ) : activeAlert === 'unread' ? (
          <>
            {alertList?.map((alertdata: any, index: number) => (
              <div key={index} className="alert_body">
                <div
                  className={
                    alertdata?.isUnread
                      ? 'alert_body-content alert_body_unread'
                      : 'alert_body-content '
                  }
                >
                  <div className="alert_body-content-head">
                    <div>
                      <h5>{alertdata?.title}</h5>
                      <Button
                        className="alert_body-content-head_btn"
                        onClick={() =>
                          handleNavigateEquipment(
                            alertdata?.deviceID,
                            alertdata?.deviceName,
                          )
                        }
                      >
                        {alertdata?.deviceName}
                      </Button>
                    </div>
                    <div className="equipment_alert-read_unread">
                      <p>{getRelativeTime(alertdata?.createdAt)}</p>
                      {/* <div
                        className={`user_management_status-data ${alertdata?.isUnread ? 'inactive' : 'active'}`}
                      >
                        {alertdata?.isUnread ? 'Unread' : 'Read'}
                      </div> */}
                      {/* <div className="markus_read_unread-btn">
                        <Button
                          onClick={() =>
                            handleMarkAsRead(
                              [alertdata?.alertID],
                              alertdata?.isUnread,
                            )
                          }
                        >
                          {alertdata?.isUnread
                            ? 'Mark as read'
                            : 'Mark as Unread'}
                        </Button>
                      </div> */}
                    </div>
                  </div>
                  <p className="alert_body-content-lines">
                    {alertdata?.description}
                  </p>
                </div>
              </div>
            ))}
            {alertList?.length > 0 && (
              <Pagination
                rowsPerPageOptions={[5, 10, 20, 30]}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
                totalPages={totalPages}
              />
            )}
            {!(alertList?.length > 0) && (
              <div className="global_audilog-nodata">
                <img src={emptyFolter} alt="nodata" width="120" height="120" />
                <h3>No Record Found!</h3>
              </div>
            )}
          </>
        ) : (
          activeAlert === 'read' && (
            <>
              {alertList?.map((alertdata: any, index: number) => (
                <div key={index} className="alert_body">
                  <div
                    className={
                      alertdata?.isUnread
                        ? 'alert_body-content alert_body_unread'
                        : 'alert_body-content '
                    }
                  >
                    <div className="alert_body-content-head">
                      <div>
                        <h5>{alertdata?.title}</h5>
                        <Button
                          className="alert_body-content-head_btn"
                          onClick={() =>
                            handleNavigateEquipment(
                              alertdata?.deviceID,
                              alertdata?.deviceName,
                            )
                          }
                        >
                          {alertdata?.deviceName}
                        </Button>
                      </div>
                      <div className="equipment_alert-read_unread">
                        <p>{getRelativeTime(alertdata?.createdAt)}</p>
                        {/* <div
                        className={`user_management_status-data ${alertdata?.isUnread ? 'inactive' : 'active'}`}
                      >
                        {alertdata?.isUnread ? 'Unread' : 'Read'}
                      </div> */}
                        {/* <div className="markus_read_unread-btn">
                          <Button
                            onClick={() =>
                              handleMarkAsRead(
                                [alertdata?.alertID],
                                alertdata?.isUnread,
                              )
                            }
                          >
                            {alertdata?.isUnread
                              ? 'Mark as read'
                              : 'Mark as Unread'}
                          </Button>
                        </div> */}
                      </div>
                    </div>
                    <p className="alert_body-content-lines">
                      {alertdata?.description}
                    </p>
                  </div>
                </div>
              ))}
              {alertList?.length > 0 && (
                <Pagination
                  rowsPerPageOptions={[5, 10, 20, 30]}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleRowsPerPageChange}
                  totalPages={totalPages}
                />
              )}
              {!(alertList?.length > 0) && (
                <div className="global_audilog-nodata">
                  <img
                    src={emptyFolter}
                    alt="nodata"
                    width="120"
                    height="120"
                  />
                  <h3>No Record Found!</h3>
                </div>
              )}
            </>
          )
        )}
      </section>

      <Popover
        className="popover-audit"
        id={dateId}
        open={dateOpen}
        anchorEl={dateAnchorEl}
        onClose={handleDateClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div>
          <DateRangePicker ranges={[selectionRange]} onChange={handleSelect} />
        </div>
      </Popover>

      <Popover
        className="popover-audits"
        id={userId}
        open={userOpen}
        anchorEl={userAnchorEl}
        onClose={handleUserClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className="user_name-popover">
          <div className="user_name-popover-search">
            <TextField
              className="user_name-popover-search_input search-input"
              variant="outlined"
              placeholder="Search evenet names here"
              fullWidth
              InputProps={{
                startAdornment: <SearchIcon className="search_icon" />,
              }}
              onChange={handleEquipmentSearch}
            />
          </div>
          <div>
            {filterEquipmentList.map((role: any, index) => (
              <div
                key={index}
                className={
                  selectedEquipment.includes(String(role.unitID))
                    ? 'role-popover-checkbox role-popover-checkbox_active'
                    : 'role-popover-checkbox'
                }
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={
                        equipmentId && equipmentId === String(role.unitID)
                      }
                      checked={selectedEquipment.includes(String(role.unitID))}
                      onChange={() => {
                        handleEquipmentSelection(String(role.unitID));
                      }}
                    />
                  }
                  label={role.equipmentModel}
                />
                {/* <div className="global_audilog_user_profile">
                            <p>{role.equipmentName}</p>
                          </div>
                          {selectedRoles.includes(String(role.unitID)) && (
                            <IconButton className="iconButton">
                              <DoneIcon className="doneIcon" />
                            </IconButton>
                          )} */}
              </div>
            ))}
          </div>
        </div>
      </Popover>
    </>
  );
};

export default Alert;
